import 'bootstrap';
import './menu.js';
import './scrollspy.js';
import 'slick-carousel/slick/slick.min.js';
import './carousel.js';
